import ServiceLayout from "@/components/ServiceLayout";
import { QuoteModal } from "@/components/QuoteModal";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

export default function Donauwoerth() {
  return (
    <ServiceLayout
      title="Umzugsunternehmen in Donauwörth"
      description="Ihr lokaler Partner für stressfreie Umzüge, Möbelmontage und Handwerksleistungen direkt in Donauwörth und Umgebung."
      image="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936df932922ae9c1fe6eaa1.jpg"
      heroBg="https://vibe.filesafe.space/1781514922662573702/assets/468feafa-df72-4f42-bb13-d8b315bbc7f6.png"
      content={
        <>
          <h2 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight">
            Ihr Umzug in Donauwörth
          </h2>
          <p className="text-lg text-neutral-600">
            Als erfahrenes Umzugsunternehmen kennen wir Donauwörth und die umliegenden Gebiete sehr gut. Egal ob Sie innerhalb von Donauwörth umziehen, neu zuziehen oder die Stadt verlassen – wir sorgen für einen reibungslosen Ablauf.
          </p>
          <p className="text-lg text-neutral-600">
            Wir planen präzise und setzen Ihren Umzug termingerecht um, damit Sie sich entspannt auf Ihr neues Zuhause freuen können.
          </p>
          <ul className="space-y-3 mt-6">
            {[
              "Ortskundige Fahrer & Planer",
              "Einrichtung von Halteverbotszonen",
              "Kurze Anfahrtswege",
              "Kostenlose Besichtigung vor Ort"
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-3 text-neutral-800 font-medium">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
                {item}
              </li>
            ))}
          </ul>
        </>
      }
      extendedContent={
        <div className="bg-white">
          <section className="py-16 bg-neutral-50">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Ihr verlässliches Umzugsunternehmen in Donauwörth</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Ein Wohnortswechsel ist immer ein großer Schritt, der gut geplant sein will. Als Ihr regionales Umzugsunternehmen für Donauwörth und Umgebung nehmen wir Ihnen die schwere Arbeit ab. Wir sorgen dafür, dass Ihr Umzug strukturiert, sicher und termingerecht verläuft, damit Sie sich ganz auf Ihr neues Zuhause konzentrieren können.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Ob innerhalb der historischen Altstadt von Donauwörth, in den umliegenden Ortsteilen oder überregional – wir kennen die örtlichen Gegebenheiten und planen die optimale Route. Bei Bedarf kümmern wir uns rechtzeitig um die Einrichtung von Halteverbotszonen, damit am Umzugstag alles reibungslos funktioniert.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Kostenloses Angebot anfordern
                      </Button>
                    </QuoteModal>
                    <Button size="lg" variant="secondary" asChild className="w-full sm:w-auto">
                      <a href="tel:+4915888640762">
                        <Phone className="w-5 h-5 mr-2" />
                        +49 15888 640762
                      </a>
                    </Button>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-8 pt-8">
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Privatumzüge in Donauwörth</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Von der kleinen Wohnung bis zum großen Einfamilienhaus – wir bieten maßgeschneiderte Lösungen für Ihren Privatumzug. Profitieren Sie von unserem Full-Service-Angebot oder buchen Sie genau die Leistungen, die Sie benötigen.
                    </p>
                  </div>
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Firmenumzüge</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Ein Standortwechsel Ihres Unternehmens erfordert Präzision. Wir transportieren Ihre Büroeinrichtung und IT-Technik sicher und effizient, um die Ausfallzeiten Ihres Betriebs so gering wie möglich zu halten.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Handwerksleistungen und Montage für Ihren Umzug</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Unser Service endet nicht beim Tragen von Kartons. Unsere erfahrenen Handwerker übernehmen die fachgerechte Demontage und Montage Ihrer Möbel. Auch komplizierte Schrankwände oder Küchen bauen wir sicher ab und am neuen Wohnort wieder auf.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Zusätzlich bieten wir Elektro- und Lichtinstallationen an. Wir schließen Ihre Lampen, Herde und Waschmaschinen an. Auch für Bodenbelagsarbeiten und kleinere Renovierungen stehen wir Ihnen in Donauwörth zur Verfügung – alles aus einer Hand für einen perfekten Start.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Jetzt beraten lassen
                      </Button>
                    </QuoteModal>
                  </div>
                </div>

                <div className="bg-primary/5 p-8 border-l-4 border-primary mt-8">
                  <h3 className="font-heading text-2xl font-bold mb-3">Festpreisgarantie und Sicherheit</h3>
                  <p className="text-neutral-700 leading-relaxed">
                    Transparenz ist uns wichtig. Nach einer kostenlosen Besichtigung in Donauwörth erhalten Sie ein verbindliches Festpreisangebot. Keine versteckten Kosten. Zudem ist Ihr Umzugsgut während des gesamten Transports und der Montagearbeiten vollumfänglich versichert.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-neutral-950 text-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto text-center">
                <h2 className="font-heading text-3xl font-bold mb-6">Warum Easy Umzug in Donauwörth?</h2>
                <div className="grid sm:grid-cols-3 gap-8 mt-12 text-left">
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Lokale Expertise</h3>
                    <p className="text-neutral-400">Wir kennen Donauwörth und die Region und planen die besten Routen für Ihren Umzug.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Sorgfalt & Sicherheit</h3>
                    <p className="text-neutral-400">Wir behandeln Ihr Eigentum mit größter Vorsicht und sind für alle Fälle voll versichert.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Alles aus einer Hand</h3>
                    <p className="text-neutral-400">Vom Transport bis zur Endreinigung bieten wir Ihnen ein umfassendes Leistungspaket.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      }
    />
  );
}
